var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),(_vm.loaded)?_c('router-view'):_vm._e(),(!_vm.loaded)?_c('div',{staticClass:"loading-effect py-5 text-center"},[_c('div',{staticClass:"spinner-border text-black-50 opacity-25"})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }